import useAppStore from 'src/store';
import LoadingIcon from './Loading';

const ComponentLoadingIcon = ({ isLoading, curtain }: { isLoading: boolean, curtain: boolean }) => {
    const appstate = useAppStore();
    return isLoading && appstate.loginState !== 'RECOVERING' ? <LoadingIcon size={30} curtain={curtain}/> : null
}

export default ComponentLoadingIcon